export const reserveCancelInfo = (state = {}, action) => {
    switch (action.type) {
        case "RESERVE_CANCEL_INFO": {
            return {
                checkInDate: action.payload.reserveCancelInfo.checkInDate,
                checkOutDate: action.payload.reserveCancelInfo.checkOutDate,
                hotelId: action.payload.reserveCancelInfo.hotelId,
                hotelName: action.payload.reserveCancelInfo.hotelName,
                roomId: action.payload.reserveCancelInfo.roomId,
                roomName: action.payload.reserveCancelInfo.roomName,
                fee: action.payload.reserveCancelInfo.fee,
                cancelContents: action.payload.reserveCancelInfo.cancelContents,
                paymentId: action.payload.reserveCancelInfo.paymentId,
                reserveId: action.payload.reserveCancelInfo.reserveId,
                roomList: action.payload.reserveCancelInfo.roomList,
            };
        }
        default: {
            return state;
        }
    }
};
